export default "__VITE_ASSET__CunES1uR__"